const BannerType = {
  SMALL: 1,
  LARGE: 2,
  POPUP: 3
}
export default BannerType
